module.exports = __webpack_public_path__ + "/login_ui/img/mn-32f8441801b9529a1c43b67a8d724cb9.svg";